<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.customers')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.customer.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.customer.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table
        [value]="customers"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="customer-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="number">{{ t('common.labels.customer_no') }}
                  <p-sortIcon field="number"></p-sortIcon>
              </th>
              <th pSortableColumn="name">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th>{{ t('common.labels.address') }}</th>
              <th>{{ t('common.labels.phone') }}</th>
            </tr>
            <tr class="filter">
              <th>
                <p-columnFilter type="text" field="number" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="name" [matchMode]="'contains'"></p-columnFilter>
              </th>
              <th></th>
              <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer>
            <tr (click)="onOpen(customer)" (keyup.enter)="onOpen(customer)" hoverOnRight="admin.customer.show" tabindex="0">
              <td><span role="link">{{ customer.number }}</span></td>
              <td><span role="link">{{ customer.name }}</span></td>
              <td><span role="link">{{ customer.address | dashWhenEmpty }}</span></td>
              <td><span role="link">{{ customer.phone | phoneNumber | dashWhenEmpty }}</span></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="3">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
